/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import LuiTextfield from '@here/lui-textfield/lui-textfield'
import { LuiSuggestionsMenuMixin } from '@here/lui-base/lui-suggestions-menu-mixin'
import template from 'lui-search.html'
import scopedCss from 'lui-search.scss'

export default class LuiSearch extends LuiSuggestionsMenuMixin(LuiTextfield) {
  static get is() {
    return 'lui-search'
  }

  static get css() {
    return scopedCss
  }

  static get template() {
    return template
  }

  get clearControl() {
    return this.shadowRoot.querySelector('lui-clear')
  }

  get searchIconControl() {
    return this.shadowRoot.querySelector('.lui-textfield__wrapper .lui-search__icon')
  }

  get uiMenu() {
    if (!this.field) {
      return
    }
    this._uiMenu = this._uiMenu || this.createMenu()
    return this._uiMenu
  }

  clearField(event) {
    event.preventDefault()
    event.stopPropagation()
    this.field.value = ''
    this._toggleClearControl()
    this.dispatchEvent(new CustomEvent('lui-textfield:cleared', { bubbles: true, composed: true }))
    this.field.focus()
  }

  init() {
    super.init()

    this._toggleClearControl()
    if (this.useSuggestions) {
      this._initSuggestions()
    }
  }

  onConnected() {
    super.onConnected()

    this._clearBound = this._clearBound || ((event) => this.clearField(event))
    this._onInputBound = this._onInputBound || this._onInput.bind(this)
    this._searchBound = this._searchBound || ((event) => this._searchIconClicked(event))

    this.clearControl.addEventListener('lui-clear:clicked', this._clearBound)
    this.searchIconControl.addEventListener('click', this._searchBound)

    this.delay(() => {
      this.field.addEventListener('input', this._onInputBound)
      if (this.useSuggestions) {
        this._registerSuggestionsEvents()
      }
    })
  }

  _onInput() {
    this.debounce(this._toggleClearControl)()
  }

  onDisconnected() {
    super.onDisconnected()

    this._unregisterSuggestionsEvents()
    this.clearControl.removeEventListener('lui-clear:clicked', this._clearBound)
    this.field.removeEventListener('input', this._onInputBound)
    this.searchIconControl.removeEventListener('click', this._searchBound)
  }

  valueChanged(oldVal, newVal) {
    super.valueChanged(oldVal, newVal)

    this.debounce(this._toggleClearControl)()
  }

  _toggleClearControl() {
    this.clearControl.style.display = this.field.value ? 'block' : 'none'
  }

  _searchIconClicked(event) {
    event.preventDefault()
    event.stopPropagation()
    this.dispatchEvent(new CustomEvent('lui-search-clicked', { bubbles: true, composed: true }))
  }
}



//////////////////
// WEBPACK FOOTER
// ./packages/lui-search/lui-search.js
// module id = 298
// module chunks = 0 1 8